import { defineMessages } from 'react-intl';

export default {
  pages: {
    landing: {
      summerContestBanner: {
        livejasmin: {
          title: {
            ...defineMessages({
              text: {
                id: 'pages.landing.summerContestBanner.livejasmin.title.text',
                defaultMessage: 'Top Model Summer Contest',
              },
            }),
          },
          prize: defineMessages({
            text: {
              id: 'pages.landing.summerContestBanner.livejasmin.prize.text',
              defaultMessage: '<b>{prize}</b> in prizes!',
            },
          }),
          date: {
            ...defineMessages({
              range: {
                id: 'pages.landing.summerContestBanner.livejasmin.date.range',
                defaultMessage: '{startDate} - {endDate}',
              },
            }),
          },
          description: {
            ...defineMessages({
              line1: {
                id: 'pages.landing.summerContestBanner.livejasmin.description.line1',
                defaultMessage: 'Join LiveJasmin, take the spotlight, and earn your share of this massive prize pool!',
              },
              line2: {
                id: 'pages.landing.summerContestBanner.livejasmin.description.line2',
                defaultMessage: 'Start your millionaire model journey.',
              },
            }),
          },
          cta: {
            ...defineMessages({
              buttonText: {
                id: 'pages.landing.summerContestBanner.livejasmin.cta.buttonText',
                defaultMessage: 'Join now',
              },
            }),
          },
        },
      },
    },
  },
};
